import React, { useEffect, useState } from 'react'
import { AppBar, Box, makeStyles, Toolbar } from '@material-ui/core'
import { Link, useLocation } from 'react-router-dom'
import { useReactiveVar } from '@apollo/client'
import EnexLogo from '../../assets/enex-logo-text.svg'
import { useAuthentication } from '../authentication/AuthenticationProvider'
import { NavigationBreadcrumbs } from './NavigationBreadcrumbs'
import { projectVar } from '../../apollo/reactive-vars'
import { MainMenu } from './MainMenu'

const useStyles = makeStyles((theme) => ({
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
  },
  logo: {
    height: theme.spacing(6),
  },
  button: {
    color: theme.palette.getContrastText(theme.palette.primary.light),
  },
}))

export function Header(): React.ReactElement {
  const { isLoggedIn } = useAuthentication()
  const classes = useStyles()
  const { pathname } = useLocation()
  const project = useReactiveVar(projectVar)
  const [isProjectPage, setIsProjectPage] = useState(false)

  const logo = <img src={EnexLogo} alt="Enex" height={48} />

  useEffect(() => {
    setIsProjectPage(pathname.startsWith('/projects/'))
  }, [pathname])

  return (
    <AppBar className={classes.appBar}>
      <Toolbar>
        {isLoggedIn ? (
          <Link to="/" className={classes.logo}>
            {logo}
          </Link>
        ) : (
          logo
        )}
        {isProjectPage && <NavigationBreadcrumbs project={project} />}

        <Box flexGrow={1} />

        <MainMenu />
      </Toolbar>
    </AppBar>
  )
}
